import {isApp, user, config} from './utils.js';
import {safeLocalStorage} from './utils/safeLocalStorage.js';

// Misma clave que Web (Chat.tsx), en el mismo dominio: la primera página sin sesión cierra la
// conversación del usuario anterior, cerrase sesión en el frontend que fuera.
const IDENTIFIED_KEY = 'gurusupWebchatIdentified';

const initChat = () => {
    if (isApp() && config.section !== 'chat') {
        return;
    }

    const orgToken = config.gurusupToken;
    if (!orgToken) {
        return;
    }

    const token = config.gurusupWebchatToken;
    const mustLogout = !token && safeLocalStorage.getItem(IDENTIFIED_KEY) === '1';
    if (token) {
        window.gurusupWebchatSettings = {token};
        safeLocalStorage.setItem(IDENTIFIED_KEY, '1');
    } else {
        safeLocalStorage.removeItem(IDENTIFIED_KEY);
    }

    const script = document.createElement('script');
    script.src = 'https://app.gurusup.com/webchat.js';
    script.async = true;
    script.setAttribute('data-gurusup-webchat', 'true');
    script.setAttribute('data-org-token', orgToken);
    // Sin firmar: se sigue mandando hasta que Gurusup pase a leer solo el token (GOT-17085).
    script.setAttribute('data-customer-id', (user && user.id) ? String(user.id) : '');

    if (config.section === 'chat') {
        script.setAttribute('data-start-expanded', 'true');
    }

    if (mustLogout) {
        script.addEventListener('load', () => window.GuruSupWebchat?.logout());
    }

    document.body.appendChild(script);
}

const toggleGurusupBubble = () => {
    const bubble = document.getElementById('gurusup-webchat-bubble');
    if (!bubble) return;
    bubble.style.display = bubble.style.display === 'none' ? 'flex' : 'none';
};

export {initChat, toggleGurusupBubble};
